import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { DocumentDetail } from './DocumentDetail'
import { DocumentsTable } from './DocumentsTable'

/**
 * The human work queue: documents awaiting registration (needs_registration) — activation is
 * the only human transition. Left: the queue; right: the selected document's review panel.
 * The selection lives in ?doc=<id> so queue items are deep-linkable.
 */
export function ReviewQueue() {
  const [searchParams, setSearchParams] = useSearchParams()
  const docParam = searchParams.get('doc')
  const parsed = docParam === null ? NaN : Number(docParam)
  const selectedId = Number.isInteger(parsed) && parsed > 0 ? parsed : null
  // Activation moves the row out of the queue — remount the table to re-query.
  const [reloadKey, setReloadKey] = useState(0)

  return (
    <div className="flex h-full min-h-0">
      <div className="w-[calc(55%+75px)] min-w-0 border-r border-gray-200">
        <DocumentsTable
          scope="review"
          reloadKey={reloadKey}
          onSelect={(id) => setSearchParams({ doc: String(id) }, { replace: true })}
        />
      </div>
      <div className="w-[calc(45%-75px)] min-w-0">
        <DocumentDetail id={selectedId} onMutated={() => setReloadKey((k) => k + 1)} />
      </div>
    </div>
  )
}
